import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-left",
  "use": "icon-caret-left-usage",
  "viewBox": "0 0 192 512",
  "content": "<symbol aria-hidden=\"true\" class=\"svg-inline--fa fa-caret-left fa-w-6\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 512\" id=\"icon-caret-left\"><path fill=\"currentColor\" d=\"M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol